exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".zan-panel-sum{background:#fff;text-align:right;font-size:14px;color:#333;line-height:30px;padding-right:15px}.zan-panel-sum span{color:red}.zan-panel-buttons{text-align:right}.zan-panel-buttons .zan-button{margin-left:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-d78453ce!./~/vue-loader/lib/selector.js?type=styles&index=0!./docs/examples/panel.vue
// module id = 239
// module chunks = 0